

























































import Vue from "vue";

import FieldCustom from "@/components/input/FieldCustom.vue";
import { ValidationObserver } from "vee-validate";
import config from "@/config";
import { mapGetters } from "vuex";

export default Vue.extend({
    name: "Login",
    components: { FieldCustom, ValidationObserver },
    data() {
        return {
            logo: config.LOGIN_LOGO_URL,
            identityEnabled: config.INTERNAL_LOGIN_ENABLED,
            username: "",
            password: "",
            passwordType: "password",
            passwordIcon: "eye-close",
            iconPrefix: this.$constants.CUSTOM_ICON_PREFIX,
            fields: {
                username: "username",
                password: "password"
            },
            rules: {
                username: ["required"],
                password: ["required"]
            }
        };
    },
    methods: {
        onSubmit() {
            this.$refs.form["validate"]().then(success => {
                if (!success) return;
                this.$store.dispatch("login/login", {
                    username: this.username,
                    password: this.password
                });
                this.$nextTick(() => {
                    this.$refs.form["reset"]();
                });
            });
        },
        showPass() {
            if (this.passwordType === "password") {
                this.passwordType = "text";
                this.passwordIcon = "eye-open";
                return;
            }
            this.passwordType = "password";
            this.passwordIcon = "eye-close";
        },
        goIdentity() {
            // first logout identity then go login page!
            if (this.loggedIn) {
                window.location.href =
                    config.INTERNAL_IDENTITY_URL +
                    "/logout?service=" +
                    encodeURI(
                        config.INTERNAL_IDENTITY_URL +
                            "/login?service=" +
                            encodeURI(this.$constants.IDENTITY_CAS_PARAM_SERVICE)
                    );
            } else {
                window.location.href =
                    config.INTERNAL_IDENTITY_URL +
                    "/login?service=" +
                    encodeURI(this.$constants.IDENTITY_CAS_PARAM_SERVICE);
            }
        },
        resetPassword() {
            this.$router.replace("/reset-password");
        },
        registry() {
            this.$router.replace("/registry");
        }
    },
    computed: {
        ...mapGetters(["loggedIn"]),
        submitDisabled(): boolean {
            return !(this.username && this.password);
        }
    }
});
